import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { BankAccountSelectorComponent } from './bank-account-selector.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        MatDialogModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        MatProgressSpinnerModule,
    ],
    declarations: [BankAccountSelectorComponent],
    exports: [
        BankAccountSelectorComponent,
    ],
})
export class BankAccountSelectorModule
{
}
